import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CurriculumRoutingModule } from './curriculum-routing.module';
import { CurriculumListComponent } from './curriculum-list/curriculum-list.component';
import { CurriculumCreateComponent } from './curriculum-create/curriculum-create.component';

@NgModule({
  declarations: [CurriculumListComponent, CurriculumCreateComponent],
  imports: [
    CommonModule,
    CurriculumRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CurriculumModule { }
